import styled from "styled-components";

const List = styled.ul.attrs({ className: "list" })`
  background: ${props => props.theme.colors.white};
`;

List.Item = styled.li.attrs({ className: "list__item" })`
  align-items: center;
  border-bottom: ${p => `1px solid ${p.theme.colors.silver}`};
  color: ${props => props.theme.colors.mako};
  display: flex;
  height: 52px;
  padding: 0 0 0 15px;

  &:hover,
  &.active {
    background: ${p => p.theme.colors.alabaster};
    color: ${p => p.theme.colors.solera};
  }
`;

export default List;
